"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeMarginNavNotification = exports.addMarginNavNotification = void 0;
var _actionTypes = require("../actionTypes");
var addMarginNavNotification = exports.addMarginNavNotification = function addMarginNavNotification() {
  return function (dispatch) {
    return dispatch({
      type: _actionTypes.ADD_MARGIN_NOTIFICATION_ICON
    });
  };
};
var removeMarginNavNotification = exports.removeMarginNavNotification = function removeMarginNavNotification() {
  return function (dispatch) {
    return dispatch({
      type: _actionTypes.REMOVE_MARGIN_NOTIFICATION_ICON
    });
  };
};